import type { QueryClient } from '@tanstack/react-query';
import { dataOutIntegrationKeys, type DataOutIntegration } from './entity';

/**
 * Imperative cache ops for the data-out connector record.
 *
 * The detail slot is the only place this record lives — the integrations
 * directory and the connections overview read it through the same key — so a
 * save or disconnect here is what refreshes their "connected" state, the way
 * saving the Ember record flipped the catalog row's flag.
 */

export function setDataOutIntegrationCache(qc: QueryClient, workspaceId: number, dataOut: DataOutIntegration): void {
  qc.setQueryData(dataOutIntegrationKeys.detail(workspaceId, dataOut.identifier), dataOut);
}

export function getDataOutIntegrationCache(
  qc: QueryClient,
  workspaceId: number,
  identifier: string,
): DataOutIntegration | null | undefined {
  return qc.getQueryData<DataOutIntegration | null>(dataOutIntegrationKeys.detail(workspaceId, identifier));
}

/**
 * A disconnected connector is "configured: no", which is `null` — not an absent
 * slot. Writing `null` keeps the config page and the directory on the same
 * answer without a refetch; removing the slot would leave observers refetching
 * a record that is gone.
 */
export function clearDataOutIntegrationCache(qc: QueryClient, workspaceId: number, identifier: string): void {
  qc.setQueryData(dataOutIntegrationKeys.detail(workspaceId, identifier), null);
}
